export const SEARCH_CONFIG = {
    maxItemsPerPage: 5,
    pathSegment: '/resultat-recherche',
    queryKey: 'q',
}
